import { useState, useContext, useCallback } from "react";
import { useQuery, gql } from '@apollo/client';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import ThemeContext from "../context/ThemeContext";
import UserContext from "../context/UserContext";
import { Outlet, Navigate,Link } from "react-router-dom";


function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);//login
   // const {loginUser, setLoginUser} = useContext(ThemeContext);
    const {theme, setTheme} = useContext(ThemeContext);
    const [redirect, setRedirect] = useState(false);
    const {users, setUsers} = useContext(UserContext);
    


    //const handleLogin = () => {
     // setUsers({...users, id: 2, usernames: username})
  //};
   
    
  
    const handleUsernameChange = (e) => setUsername(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const client = new ApolloClient({
        uri: 'http://212.68.57.195:8080/v1/graphql',
        cache: new InMemoryCache(),
      });
  
      const LOGIN_QUERY = gql`
        query Login($username: String!, $password: String!) {
          tbl_login(where: { user_name: { _eq: $username }, pass: { _eq: $password }, active: { _eq: true } }) {
            user_name
          }
        }
      `;
      
      const { data } = await client.query({
        query: LOGIN_QUERY,
        variables: { username, password },
      });
  
      const success = data.tbl_login.length > 0;
  
      if (success) {
       // <Navigate to="/AuthLayout" replace/>;
        // Kullanıcı girişi başarılı, ana sayfaya yönlendir
        
       setError(isLoggedIn);
       //setIsLoggedIn(true);
       
       localStorage.setItem('login', 'true');
       localStorage.setItem('loginuser', username);
       // set redirect flag 
      // setUsers.login.setLoginUser({username});
      // handleLogin();
       setUsers({...users,loginIng:true, usernames: username});
       setRedirect(true); 
       
       
           
       
      } else {
        // Kullanıcı girişi başarısız, hata mesajı göster
        setError('user name or password denied.');
      }
    };

    if (redirect) {
        window.location.reload()
       // <Navigate to="/"  />; // render the redirect here
      }
  
    return (
        <div className="max-w-md mx-auto py-12" >
         <h1 className="text-2xl">Sign In</h1>
        
      <form onSubmit={handleSubmit}className="flex flex-col gap-4 mt-8 rounded-md border-solid outline border-slate-100  py-12 px-12">
        <label className=" space-x-0.5 via-violet-800 " typeof="text">
          User Name : 
          <input  
           placeholder="Enter Your User Name"
           className="p-2 bg-gray-100 rounded-md w-px{40} focus:border-violet-700" 
           type="text"
            value={username} onChange={handleUsernameChange} 
            />
        </label >
        <label className="via-violet-300">
          Password  :  
          <input  
          
          placeholder="Enter Your Password"
           className="p-2 bg-gray-100 rounded-md"
           type="password" 
           value={password} onChange={handlePasswordChange} 
           />
        </label>
        
        <button 
        className="p-4 bg-violet-300 black rounded-md cursor-pointer hover:bg-slate-500" 
        type="submit">Login</button>
        {error && <div>{error}</div>}

        

        
        
      </form>
      
      </div>
      
    );
  }


/*const SingIn = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const handleSubmit = useCallback(
        (e) => {
        e.preventDefault();
    }, [email, password]);

return (
<div className="max-w-md mx-auto py-12">
<h1 className="text-2xl">Sing In</h1>
<form onSubmit={handleSubmit}className="flex flex-col gap-4 mt-8">

    <input 
    type="email" 
    placeholder="Enter Your User Name or Email"
    className="p-2 bg-gray-100 rounded-md"
    value={email}
    onChange={(e) => setEmail(e.currentTarget.value)}
    />
    <input 
    type="password" 
    placeholder="Enter Your Password"
    className="p-2 bg-gray-100 rounded-md"
    value={password}
    onChange={(e) => setPassword(e.currentTarget.value)}
    />
    <input
    type="submit" 
    className="p-4 bg-violet-300 black rounded-md" 
    value="Login"
    />

</form>
</div>
)
};*/

function SingIn() {
    return (
      <div className="App">
        
        <Login />
      </div>
    );
  }

export default SingIn;